module.exports = __webpack_public_path__ + "static/media/default.a2b18dbe.png";